import {ThemeProvider} from '@primer/react-brand'
import type {FlexSuiteOverviewPage} from '../../../lib/types/contentful'
import {FlexSuiteHero} from '../components/FlexSuiteHero'
import {FlexSuiteSubNav} from '../components/FlexSuiteSubNav'
import {FeaturedContent} from './components/FeaturedContent'
import {PricingSection} from './components/PricingSection/PricingSection'

export type OverviewTemplateProps = {
  page: FlexSuiteOverviewPage
}

export function OverviewTemplate({page}: OverviewTemplateProps) {
  const {template, settings} = page.fields
  const pageColorMode = settings?.fields.colorMode ?? 'light'
  const {
    heroHeading,
    heroLabel,
    heroDescription,
    heroCtaOne,
    heroCtaTwo,
    heroTertiaryDescription,
    heroVariant,
    heroImage,
    heroCarousel,
    heroIconCards,
    heroImageCards,
    subNav,
    featureHeading,
    featureLabel,
    featureDescription,
    featureLink,
    featureDetailsOne,
    featureRiverAccordion,
    featureRiverStack,
    featureDetailsTwo,
    featureRiverBreakout,
    featureBreakoutTabs,
    includePricingSection,
    pricingHeading,
    pricingLabel,
    pricingDescription,
    pricingOptions,
    pricingCtas,
    pricingTiles,
    pricingTilesLead,
  } = template.fields

  const isExpressive = heroVariant === 'Carousel' || heroVariant === 'Stacked'

  return (
    <ThemeProvider colorMode={pageColorMode}>
      {subNav && <FlexSuiteSubNav subNav={subNav} />}
      <FlexSuiteHero
        heroHeading={heroHeading}
        heroLabel={heroLabel}
        heroDescription={heroDescription}
        heroCtaOne={heroCtaOne}
        heroCtaTwo={heroCtaTwo}
        heroTertiaryDescription={heroTertiaryDescription}
        heroVariant={heroVariant}
        heroImage={heroImage}
        heroCarousel={heroCarousel}
        heroIconCards={heroIconCards}
        heroImageCards={heroImageCards}
        options={{
          variant: isExpressive ? 'gridline-expressive' : 'gridline',
          align: isExpressive ? 'start' : 'center',
          enableAnimation: true,
        }}
      />
      <FeaturedContent
        featureHeading={featureHeading}
        featureLabel={featureLabel}
        featureDescription={featureDescription}
        featureLink={featureLink}
        featureDetailsOne={featureDetailsOne}
        featureRiverAccordion={featureRiverAccordion}
        featureRiverStack={featureRiverStack}
        featureDetailsTwo={featureDetailsTwo}
        featureRiverBreakout={featureRiverBreakout}
        featureBreakoutTabs={featureBreakoutTabs}
      />
      {includePricingSection && (
        <PricingSection
          pricingHeading={pricingHeading}
          pricingLabel={pricingLabel}
          pricingDescription={pricingDescription}
          pricingOptions={pricingOptions}
          pricingCtas={pricingCtas}
          pricingTiles={pricingTiles}
          pricingTilesLead={pricingTilesLead}
        />
      )}
    </ThemeProvider>
  )
}
